export const footerCopy = {
  footer_customize: "主题",
  footer_site_colours: "网站颜色",
  footer_code_font: "代码字体",
  footer_site_colours_options_system: "系统",
  footer_site_colours_options_always_light: "常亮",
  footer_site_colours_options_always_dark: "常暗",
}